export default "__VITE_ASSET__eeb67090__"